import React from 'react'

import { Typography } from '~components/internal'

import './TwilioAccountSection.scss'
import { truncateSid } from './utils'

export const TWILIO_LOGO_URL =
  'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/twilio-icon.png'

export const TwilioAccountSidCode: React.FC<{ sid: string }> = ({ sid }) => (
  <Typography component='code' variant='body2' className='twilio-account-sid-code'>
    {truncateSid(sid)}
  </Typography>
)
